import { BankType } from 'models/bank.model';
import { ActiveType, VendorFormType, VendorType } from 'models/vendors.model';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type VendorContextType = {
  vendorFormData: VendorFormType[];
  setVendorFormData: (Value: VendorFormType[]) => void;
  vendorToEdit: VendorType;
  setVendorToEdit: Dispatch<SetStateAction<VendorType>>;
  active: ActiveType | null;
  setActive: (item: ActiveType | null) => void;
  step: number;
  setStep: (value: number) => void;
  activeVendorProfile: VendorType;
  setActiveVendorProfile: Dispatch<SetStateAction<VendorType>>;
  bankList: BankType[];
};

export const VendorContext = createContext({} as VendorContextType);

const useVendorContext = () => {
  const context = useContext(VendorContext);
  return context;
};

export default useVendorContext;
